/**
 * Tabelas da sala (TablesDock) dos plugins, em Configurações da mesa > Plugins. Mestres ativam e
 * desativam; desativada, a tabela sai da mesa para todos e os dados ficam guardados até alguém
 * ativar de novo ou apagar. As que vêm com o RPG Desk (o tracker de combate e as macros) não
 * passam por aqui: estão sempre na mesa, no menu Painéis (docs/spec/room-menus.md).
 */
import { useT } from '../i18n/index.js';
import { useApp } from '../store.js';
import { Button } from '../ui/controls.js';
import { askConfirm } from '../ui/prompt.js';

export type RoomTable = { dataType: string; title: string };

/** Uma tabela: estado e, para mestres, os botões. */
export function RoomTableRow({ table, canManage }: { table: RoomTable; canManage: boolean }) {
  const t = useT();
  const dock = useApp((s) => s.library.find((i) => i.kind === 'dock' && i.dataType === table.dataType));
  const createItem = useApp((s) => s.createLibraryItem);
  const setDockActive = useApp((s) => s.setDockActive);
  const deleteItem = useApp((s) => s.deleteLibraryItem);
  const type = table.title || table.dataType;
  const state = !dock ? 'off' : dock.inactive ? 'stored' : 'active';

  const enable = () => {
    // desativada: os dados estão guardados; reativar traz a mesma tabela
    if (dock) setDockActive(dock.id, true);
    else createItem({ kind: 'dock', name: type, dataType: table.dataType, parentId: null });
  };
  const disable = async () => {
    if (!dock) return;
    const sure = await askConfirm({ title: t('library.dock.disable', { type }), message: t('library.dock.disable.confirm', { type }), action: t('library.dock.disable.go') });
    if (sure) setDockActive(dock.id, false);
  };
  const erase = async () => {
    if (!dock) return;
    const sure = await askConfirm({ title: t('library.dock.erase', { type }), message: t('library.dock.erase.confirm', { type }), action: t('library.dock.erase.go'), danger: true });
    if (sure) deleteItem(dock.id);
  };

  return (
    <li className="rd-tables__row">
      <span className="rd-tables__name">{type}</span>
      <span className={`rd-tables__state rd-tables__state--${state}`}>{t(`config.tables.${state}`)}</span>
      {canManage ? (
        <span className="rd-tables__actions">
          {state === 'active' ? (
            <Button variant="secondary" aria-label={t('library.dock.disable', { type })} onClick={() => void disable()}>
              {t('config.tables.disable')}
            </Button>
          ) : (
            <Button variant="secondary" aria-label={t('library.dock.enable', { type })} onClick={enable}>
              {t('config.tables.enable')}
            </Button>
          )}
          {state === 'stored' ? (
            <Button variant="secondary" aria-label={t('config.tables.erase.label', { type })} onClick={() => void erase()}>
              {t('config.tables.erase')}
            </Button>
          ) : null}
        </span>
      ) : null}
    </li>
  );
}
